import React, { Component } from "react";
import { connect } from "react-redux";
import { cloud } from "@vitalsource/vstui/colors";
import styled from "styled-components";
import { selectors as uiLibrarySelectors } from "../../../../../redux/ui/library";
import { selectors as searchSelectors } from "../../../../../redux/search";
import * as bridgesawActions from "../../../../../redux/bridgesaw/actions";
import { t, Translation } from "../../../../core/translate";
import SearchField from "../../../../components/search-field";
import Spinner from "../../../../components/spinner";
import { LicensedHeader } from "../../panel/header/";
import TruncateMarkup from "react-truncate-markup";
import NullSearchPanelResults from "../../../../components/icons/NullSearchPanelResults";
import ZeroSearchResults from "../../../../components/icons/ZeroSearchResults";
import { actions as routerActions } from "../../../../../redux/router";
import { styledMedia } from "../../../../components/mediaquery/breakpoints";
import { searchBookContent } from "../../../../../redux/search/actions";
import { BridgeHeader } from "../../panel/header";
import { isLicensedBook } from "../../../../../redux/books/selectors";
import {
  hasCompletedSearch,
  isSearchingContent
} from "../../../../../redux/bridgesaw/selectors";
import PanelBack from "../../panel/back";
import { OffScreenStyles } from "../../../../components/mixins";
import { actions as modalActions } from "../../../../../redux/modals";
import { selectors as bridgeSelectors } from "../../../../../redux/bridge";

const SearchPanelWrapper = styled.div`
  background-color: ${cloud.getShade(2)};
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;

  div[role="status"] {
    ${OffScreenStyles}
  }
`;

const SeachPanelField = styled(SearchField)`
  margin-top: 25px;
  min-width: 360px;
  ${styledMedia.small`
    min-width: 0;
    width: 100%;
  `};
`;

const ChapterTitle = styled.h3`
  font-weight: 600;
  font-size: 1.6rem;
  color: ${cloud.getShade(10)};
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  padding-top: 15px;
`;
const ResultsCount = styled.span`
  font-size: 1.4rem;
  color: ${cloud.getShade(8)};
  float: right;
  font-weight: 300;
  padding-top: 10px;
`;

const SearchResults = styled.ul`
  padding: 0;
  margin: 0;
  border-bottom: 1px solid #c8c7cc;
`;

const SearchResultsWrapper = styled.div`
  flex: 1;
  display: flex;
  min-height: 0;
`;

const PanelPadding = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  ${styledMedia.small`
    margin: 0 10px;
  `};
`;

const SearchResultText = styled.li`
  list-style: none;
  border-top: 1px solid #c8c7cc;
  cursor: pointer;
  padding: 10px 0;

  a {
    font-weight: 400;
    font-size: 1.5rem;
    color: ${cloud.getShade(10)};
    width: 100%;
    display: inline-block;
  }

  span {
    &.highlight {
      background-color: #fff65b;
    }
  }

  &:first-child {
    border-top: none;
  }
`;

const SearchResultsContainer = styled.ul`
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  flex: 1;
`;

const NoResultsContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  svg {
    margin: 0 auto;
  }
`;

const ZeroSearchResultsContainer = styled.div`
  text-align: center;
  margin: 0 auto;
  color: #3c3c3c;
  svg {
    width: 400px;
  }
  div:first-of-type {
    font-weight: 600;
    font-size: 28px;
  }
  div:nth-of-type(2) {
    font-size: 16px;
  }
  ${styledMedia.small`
    svg {
      max-width: 100%;
    }
  `};
`;

const SearchListItems = styled.li`
  padding: 0 30px;
  &:last-child {
    ul {
      border-bottom: none;
    }
  }
`;

class SearchPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      localQuery: props.query,
      resultsToRender: 25
    };
    this.cachedBrokenUpResults = {};
    this.cachedSortedChapters = {};
    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    if (this.props.query) {
      this.search();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const currentQuery = this.props.query;
    if (
      currentQuery !== prevProps.query &&
      currentQuery !== this.state.localQuery
    ) {
      this.setState({ localQuery: currentQuery });
    }

    this._renderMoreResults();
  }

  componentWillUnmount() {
    this.cachedResults = undefined;
    this.cachedSortedChapters = {};
    this.cachedBrokenUpResults = {};
    this.lastResultsToRender = undefined;
  }

  onScroll() {
    this._renderMoreResults();
  }

  _renderMoreResults() {
    if (
      this.lastlink &&
      this.lastlink.getBoundingClientRect().top < window.innerHeight + 500 &&
      this.state.resultsToRender < this.props.results.length
    ) {
      this.setState(prevState => ({
        resultsToRender: prevState.resultsToRender + 25
      }));
    }
  }

  search() {
    this.cachedResults = undefined;
    this.cachedSortedChapters = {};
    this.cachedBrokenUpResults = {};
    this.lastResultsToRender = undefined;
    this.props.searchBookContent(this.props.isbn, this.state.localQuery);
  }

  navigateToBook(result, isbn) {
    this.props.launchBook(isbn, {
      location: result,
      search: this.state.localQuery,
      context: "search-result"
    });
  }

  parseResult(result, hasAvailableUserCredits, isCreditAsset) {
    if (!result.text) {
      return false;
    }

    const { pos, len } = result;

    const spans = [];
    spans.push(
      <span
        ref={link => {
          this.lastlink = link;
        }}
        key={`search-result-${result.result_id}-start`}
        style={{ display: "inline" }}
      >
        {result.text.slice(0, pos)}
      </span>
    );
    spans.push(
      <span
        key={`search-result-${result.result_id}-${result.pos}-middle`}
        style={{ display: "inline" }}
        className="highlight"
      >
        {result.text.slice(pos, pos + len)}
      </span>
    );

    spans.push(
      <span
        key={`search-result-${result.result_id}-${result.pos}-end`}
        style={{ display: "inline" }}
      >
        {result.text.slice(pos + len)}
      </span>
    );

    let text = (
      <TruncateMarkup lines={2}>
        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            hasAvailableUserCredits && isCreditAsset
              ? this.props.openModal("BorrowBookModal", {
                  isbn: this.props.isbn,
                  result: result,
                  localQuery: this.state.localQuery
                })
              : this.navigateToBook(result, this.props.isbn);
          }}
        >
          {spans}
        </a>
      </TruncateMarkup>
    );

    return (
      <SearchResultText key={`search-result-${result.result_id}-${result.id}`}>
        {text}
      </SearchResultText>
    );
  }

  noResults() {
    return (
      <NoResultsContainer>
        <ZeroSearchResultsContainer>
          <ZeroSearchResults />
          <div>
            <Translation id="search.nothing-here">Nothing here!</Translation>
          </div>
          <div>
            <Translation id="search.check-spelling">
              Check your spelling or try a different search term.
            </Translation>
          </div>
        </ZeroSearchResultsContainer>
      </NoResultsContainer>
    );
  }

  nullSearch() {
    return (
      <NoResultsContainer>
        <NullSearchPanelResults />
      </NoResultsContainer>
    );
  }

  _breakUpResult(result) {
    let chunks = [],
      start = 0;
    for (let i = 0; i < (result.term_locs && result.term_locs.length); i++) {
      let j = i + 1;
      let thisLoc = result.term_locs[i];
      let nextPos = result.term_locs[j] && result.term_locs[j].pos;
      let chunk = {};
      let text;
      if (nextPos) {
        text = result.text.slice(start, nextPos);
      } else {
        text = result.text.slice(start);
      }

      let beginning = text.slice(0, thisLoc.pos - start);
      let k;
      for (k = thisLoc.pos; k > 0; k--) {
        if (beginning[k] === " ") {
          break;
        }
      }

      let splitBeginning = beginning.slice(0, k).split(" ");

      const newBeginning = splitBeginning.slice(-5).join(" ");
      const ellipsis = splitBeginning.length > 5 ? "... " : "";
      chunk.text = `${ellipsis}${newBeginning}${text.slice(k)}`;
      chunk.pos =
        thisLoc.pos -
        start -
        splitBeginning.slice(0, -5).join(" ").length -
        Math.min(splitBeginning.slice(0, -5).length, 1) +
        ellipsis.length;
      chunk.len = thisLoc.len;
      chunk.result_id = result.id;
      chunk.id = i;
      chunk.cfi = result.cfi;
      start = result.term_locs[i].pos + result.term_locs[i].len;
      chunks.push(chunk);
    }
    return chunks;
  }

  renderResults() {
    const {
      isSearchBookContentSearching,
      results,
      hasAvailableUserCredits,
      isCreditAsset
    } = this.props;
    if (isSearchBookContentSearching) {
      return <Spinner />;
    } else {
      if (results.length) {
        if (
          (this.cachedResults || []).length === results.length ||
          this.lastResultsToRender === this.state.resultsToRender
        ) {
          return this.cachedResults;
        }

        this.lastResultsToRender = this.state.resultsToRender;
        if (!Object.keys(this.cachedSortedChapters).length) {
          this.cachedSortedChapters = results.reduce((acc, result) => {
            if (!acc[result.chapter_title]) {
              acc[result.chapter_title] = [];
            }
            acc[result.chapter_title].push(result);
            return acc;
          }, {});
        }

        let count = 0;
        this.cachedResults = Object.keys(this.cachedSortedChapters).map(
          chapter => {
            let chapterNumber = 0;
            const chapterResults = this.cachedSortedChapters[chapter].map(
              result => {
                if (this.cachedBrokenUpResults[result.id]) {
                  chapterNumber += this.cachedBrokenUpResults[result.id].length;
                  return this.cachedBrokenUpResults[result.id];
                }
                const chunks = this._breakUpResult(result);
                chapterNumber += chunks.length;
                count += chunks.length;
                if (count > this.state.resultsToRender) {
                  return;
                }
                this.cachedBrokenUpResults[result.id] = chunks.map(chunk =>
                  this.parseResult(
                    chunk,
                    hasAvailableUserCredits,
                    isCreditAsset
                  )
                );
                return this.cachedBrokenUpResults[result.id];
              }
            );
            return (
              <SearchListItems
                key={`search-list-${this.cachedSortedChapters[chapter][0].id}`}
              >
                <ChapterTitle>{chapter}</ChapterTitle>
                <ResultsCount>({chapterNumber})</ResultsCount>
                <SearchResults>{chapterResults}</SearchResults>
              </SearchListItems>
            );
          }
        );
        return this.cachedResults;
      }
      return results.length === 0 && this.props.query
        ? this.noResults()
        : this.nullSearch();
    }
  }

  clearInput = () => {
    this.setState({ localQuery: "" });
  };

  render() {
    const {
      hasCompletedSearch,
      isbn,
      isSearchBookContentSearching,
      licensedHeader
    } = this.props;
    return (
      <SearchPanelWrapper>
        <PanelBack label={t("search.content-search", "Content search")} />
        {licensedHeader ? (
          <LicensedHeader isbn={isbn} context="search-panel" />
        ) : (
          <BridgeHeader isbn={isbn} context="search-panel" />
        )}
        <PanelPadding>
          <SeachPanelField
            value={this.state.localQuery}
            nativeFormControlRef={x => (this.searchField = x)}
            onChange={(e, value) => this.setState({ localQuery: value })}
            onSubmit={value => this.search()}
            clearInput={this.clearInput}
            labelHidden
            label={t(
              "reader.search.search-book-content",
              "Search Book Content"
            )}
            placeholder={t(
              "reader.search.search-book-content",
              "Search Book Content"
            )}
          />
          <SearchResultsWrapper>
            <SearchResultsContainer onScroll={this.onScroll}>
              {this.renderResults()}
            </SearchResultsContainer>
          </SearchResultsWrapper>
        </PanelPadding>
        <div role="status">
          {isSearchBookContentSearching
            ? t("search.loading", "Loading search results")
            : hasCompletedSearch
            ? t("search.finished-loading", "Finished loading search results")
            : ""}
        </div>
      </SearchPanelWrapper>
    );
  }
}

const mapStateToProps = (state, props) => {
  const panel = uiLibrarySelectors.getPanel(state);
  const isbn = panel.data.isbn;
  return {
    query: searchSelectors.getDefaultSearchTerm(state, isbn),
    isbn,
    type: panel.type,
    isSearchBookContentSearching: isSearchingContent(state, isbn),
    hasCompletedSearch: hasCompletedSearch(state, isbn),
    results: searchSelectors.getSearchBookContent(state, isbn),
    licensedHeader: isLicensedBook(state, isbn),
    hasAvailableUserCredits: bridgeSelectors.hasAvailableUserCredits(state),
    isCreditAsset: bridgeSelectors.isCreditAsset(state, isbn)
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    searchBookContent: (isbn, query) =>
      dispatch(searchBookContent(isbn, query)),
    launchBook: (isbn, options) =>
      dispatch(
        bridgesawActions.launchBookWithActivationIfNeeded(isbn, options)
      ),
    push: path => {
      dispatch(routerActions.push(path));
      location.reload();
    },
    openModal: (modal, props) => dispatch(modalActions.openModal(modal, props))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPanel);
